import styled from 'styled-components'

export const PageNotFoundDiv = styled.div`

display:flex;
flex-direction:column;
justify-content:center;
text-align:center;
background-color:#1e90ff;
min-height:100vh;

`